import { OverlayContainer } from '@angular/cdk/overlay';
import { Platform } from '@angular/cdk/platform';
import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class DynamicOverlayContainer extends OverlayContainer {
  constructor(@Inject(DOCUMENT) document: Document, platform: Platform) {
    super(document, platform);
  }
  public setContainerElement(containerElement: HTMLElement): void {
    this._containerElement = containerElement;
  }
}
